// First: stamp the document ground before the stylesheet paints.
import './ui/ground.js';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { initPlatform } from './platform/bootstrap.js';
import './i18n/index.js';
// The stylesheet is linked from `index.html` rather than imported here, so the
// launch cover painted there is styled before any script runs.

const container = document.getElementById('root');
if (container === null) throw new Error('#root is missing from index.html');

// Swaps in the Capacitor-backed platform when running inside a native shell.
// A no-op in a browser tab, and it cannot reject — the app must render either
// way, so this deliberately does not block the first paint.
void initPlatform();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
